import type { Group } from 'store/units/types';
import { getDefaultColor } from './getColors';

export const getDefaultData = (): Omit<
  Group,
  'key' | 'unitKeys' | 'textBoxKey'
> => {
  return {
    title: 'Click to edit',
    body: '',
    color: getDefaultColor(),
  };
};
